import React from 'react';

const VatIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" {...props}>
      <path d="M2.62459 4.95866C3.91326 4.95866 4.95793 3.91399 4.95793 2.62533C4.95793 1.33666 3.91326 0.291992 2.62459 0.291992C1.33593 0.291992 0.29126 1.33666 0.29126 2.62533C0.29126 3.91399 1.33593 4.95866 2.62459 4.95866Z" />
      <path d="M11.3746 13.7087C12.6633 13.7087 13.7079 12.664 13.7079 11.3753C13.7079 10.0867 12.6633 9.04199 11.3746 9.04199C10.0859 9.04199 9.04126 10.0867 9.04126 11.3753C9.04126 12.664 10.0859 13.7087 11.3746 13.7087Z" />
      <path d="M13.075 0.925569C12.6194 0.470123 11.8809 0.470123 11.4253 0.925569L0.92529 11.4256C0.622008 11.7185 0.500376 12.1523 0.607144 12.5602C0.713912 12.9681 1.03246 13.2866 1.44037 13.3934C1.84827 13.5001 2.28204 13.3785 2.57496 13.0752L13.075 2.57524C13.5304 2.11965 13.5304 1.38115 13.075 0.925569Z" />
    </svg>
  );
};

export default VatIcon;
